import React, { memo } from 'react';
export const Footer = memo(function Footer() {
  return <footer className="py-8 px-4 border-t border-gray-800 bg-[#FFFFFF]" data-id="element-53">
      <div className="max-w-4xl mx-auto text-center" data-id="element-54">
        <p className="text-gray-400 text-sm mb-2" data-id="element-55">
          © {new Date().getFullYear()} Megapack Domina Tu Mente. Todos los
          derechos reservados.
        </p>
        <p className="text-gray-500 text-xs" data-id="element-56">Construye Progreso</p>
      </div>
    </footer>;
});